module.exports = __webpack_public_path__ + "1d2bbff7e1f3b47d31c0ee79d54908e8.svg";